import { render, staticRenderFns } from "./DomainView.vue?vue&type=template&id=92006454&"
import script from "./DomainView.vue?vue&type=script&lang=js&"
export * from "./DomainView.vue?vue&type=script&lang=js&"
import style0 from "./DomainView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports